<fieldset [attr.id]="questionId + '-fieldset'">
  @let title = text() ;
  @if (title) {
    <p #label id="{{ questionId }}-label-content" class="field-label" [innerHTML]="title"></p>
  }
  <!--    fixMe error label sometimes displaying with no real errors-->
  @if (controlHasError() && baseForm.errorMap.size > 0 && allTouched()) {
    <div class="alert  alert-danger error pill form-error-list">
      <div id="{{questionId}}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
        <div>
          <ul>
            @for (err of baseForm.errorMap.get(questionId!); track $index) {
              <li>
                <span> {{ determineErrorMessage(err.error!, control, question) }}</span>
              </li>
            }
            @if (controlNameHasError('day')) {
              @for (err of baseForm.errorMap.get(questionId! + '-day'); track $index) {
                <li>
                  <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
                </li>
              }
            }
            @if (controlNameHasError('month')) {
              @for (err of baseForm.errorMap.get(questionId! + '-month'); track $index) {
                <li>
                  <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
                </li>
              }
            }
            @if (controlNameHasError('year')) {
              @for (err of baseForm.errorMap.get(questionId! + '-year'); track $index) {
                <li>
                  <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
                </li>
              }
            }
          </ul>
        </div>
      </div>
    </div>
  }
  <form [formGroup]="form">
    <div class="horizontal" id="{{question.id}}">
      <div class="form-group position-relative">
        <label id="{{getDateFieldName('day')}}-label" aria-label="Day of Month (dd)" #labelDay
               [for]="question.id + '-day'" class="field-label">{{ dateLabels[0] }} </label>
        <input #input type="text" integer
               class="form-control very-short {{inputClass}}"
               [formControl]="day!"
               [attr.name]="question.id"
               [attr.id]="question.id + '-day'"
               [attr.autocomplete]="question.id + '-day'"
               [attr.aria-invalid]="controlNameHasError('day')"
               [attr.aria-labelledby]="question.id + '-day-err ' + question.id + '-day-label '"
               aria-live="polite"
               [attr.aria-required]="question.required"
               [required]="question.required"
               [maxLength]="2"
               [ngClass]="{ 'is-invalid': controlNameHasError('day') } +' mt-3'"
               (keydown.enter)="onEnter($event)"/>
      </div>
      <div class="form-group position-relative">
        <label id="{{getDateFieldName('month')}}-label" aria-label="Month of Year (mm)" #labelMonth
               [for]="getDateFieldName('month')" class="field-label">{{ dateLabels[1] }} </label>
        <input #input type="text" integer
               [formControl]="month!"
               [attr.name]="question.id"
               [attr.id]="getDateFieldName('month')" class="form-control very-short {{inputClass}}"
               [attr.autocomplete]="getDateFieldName('month')"
               [attr.aria-invalid]="controlNameHasError('month')"
               [attr.aria-required]="question.required"
               [attr.aria-labelledby]="getDateFieldName('month')+'-label ' + getDateFieldName('month')+'-err'"
               [required]="question.required"
               [maxLength]="2"
               [ngClass]="{ 'is-invalid': controlNameHasError('month') } +' mt-3'"
               (keydown.enter)="onEnter($event)"/>
      </div>

      <div class="form-group position-relative">
        <label id="{{getDateFieldName('year')}}-label" aria-label="Year (yyyy)" #labelYear
               [for]="getDateFieldName('year')" class="field-label">{{ dateLabels[2] }} </label>
        <input #input type="text" integer
               [formControl]="year!"
               [attr.name]="question.id"
               [attr.id]="getDateFieldName('year')" class="form-control short {{inputClass}}"
               [attr.autocomplete]="getDateFieldName('year')"
               [attr.aria-required]="question.required"
               [attr.aria-invalid]="controlNameHasError('year')"
               [attr.aria-labelledby]="getDateFieldName('year')+'-label ' + getDateFieldName('year')+'-err'"
               [required]="question.required"
               [maxLength]="4"
               [ngClass]="{ 'is-invalid': controlNameHasError('year') } +' mt-3'"
               (keydown.enter)="onEnter($event)"
               (select)="revalidateInput()"/>
      </div>

      @if (anyTouched() || baseForm.isSubmitted()) {
        <div #feedback class="feedback-icon form-group" aria-hidden="true">
          <i class="fa" aria-hidden="true"
             [ngClass]="{ 'fa-check-circle' : !formHasError() && allValid(), 'fa-times-circle' : formHasError() || !allValid() }"></i>
        </div>
      }

    </div>
    @if (standalone) {
      <div class="option-row row mt-8 mx-0">
        <div class="px-0 text-end">
          <button class="btn primary rounded-pill confirm-button"
                  [disabled]="baseForm.loading || baseForm.preventSave"
                  [attr.aria-label]="getLabel() + '.confirm_button'"
                  (click)="onEnter($event)"
                  (keydown.enter)="onEnter($event)">
            @if (baseForm.loading) {
              <span class="spinner-border spinner-border-sm mr-1"></span>
            }
            {{ messages.getText('WILL.button.save-and-continue') }}
          </button>
        </div>
      </div>
    }
  </form>

</fieldset>
